<template>
  <div :class="classnames">
    <modal-close-button />
  </div>
</template>

<script>
  import ModalCloseButton from './ModalCloseButton'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'modal-control'

  export default {
    name: 'ModalControl',
    components: {
      'modal-close-button': ModalCloseButton
    },
    mixins: [ bem ],
    props: {
      isOpen: {
        type: Boolean
      }
    },
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Modal/ModalControl.vue